import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Select from "react-select";
import UploadComponent from "../Components/uploadComponent";
import ReactQuill, { Quill } from "react-quill";
import { createBlogs } from "../../../store/slices/blogsSlice";

const Font = Quill.import("attributors/class/font");
Font.whitelist = [
  "arial",
  "comic-sans",
  "courier-new",
  "inter",
  "georgia",
  "helvetica",
  "lucida",
];
Quill.register(Font, true);

const Size = Quill.import("attributors/class/size");
Size.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "32px",
  "34px",
  "36px",
  "38px",
  "40px",
  "42px",
  "44px",
  "46px",
  "48px",
  "50px",
  "52px",
  "54px",
  "56px",
  "58px",
  "60px",
  "62px",
  "64px",
  "66px",
  "68px",
  "70px",
  "72px",
  "74px",
  "76px",
  "78px",
  "80px",
  "82px",
  "84px",
  "86px",
  "88px",
  "90px",
  "92px",
  "94px",
  "96px",
  "98px",
  "100px",
];
Quill.register(Size, true);

const CreateBlogModal = ({ isOpen, toggle }) => {
  const serviceFormRef = useRef();
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState({
    title: "",
    subTitle: "",
    data: "",
    coverImage: "",
    createdBy: null,
  });
  const {
    register,
    trigger,
    control,
    formState: { errors },
    setValue,
    reset,
    resetField,
  } = useForm({
    defaultValues: {
      title: "",
      subTitle: "",
      data: "",
      category: "",
      coverImage: "",
      createdBy: 1,
    },
  });

  const [formFieldsValidation, setFormFieldsValidation] = useState({
    title: {
      ...register("title", { required: "This field is required" }),
    },
    subTitle: {
      ...register("subTitle", { required: "This field is required" }),
    },
    data: {
      ...register("data", { required: "This field is required" }),
    },
    category: {
      ...register("category", { required: "This field is required" }),
    },
    // createdBy: {
    //   ...register("createdBy", { required: "This field is required" }),
    // },
  });

  const [file, setFile] = useState(null);

  useEffect(() => {
    setValue("coverImage", file);
    setFormFields({ ...formFields, coverImage: file });
  }, [file]);

  const handleInput = (event, key) => {
    let value;
    if (key === "data") {
      value = event;
    } else {
      value = event.target.value;
    }
    console.log(value, key, "value");

    setValue(key, value);
    setFormFields({ ...formFields, [key]: value });
  };

  const handleSelect = (e, key) => {
    console.log(e, key, "value");
    setValue(key, e);
    setFormFields({ ...formFields, [key]: e });
  };

  const createBlogsData = async () => {
    try {
      if (await trigger()) {
        let formData = new FormData();

        Object.keys(formFields).map((key) => {
          formData.append(key, formFields[key]);
        });

        let createBlog = await dispatch(createBlogs(formData));
        console.log("CREATE", createBlog.payload);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      reset();
      resetField();
      setFormFields({
        title: "",
        subTitle: "",
        data: "",
        coverImage: "",
        createdBy: null,
      });
    }
  }, [isOpen]);

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      [{ font: Font.whitelist }, { size: Size.whitelist }],
      [{ align: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [{ color: [] }, { background: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "font",
    "align",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader>Add new BCC email recipient</ModalHeader>
      <ModalBody>
        <div className="px-2">
          <div className="d-flex gap-2 mt-2">
            <div className="w-full ">
              <Label>Email<span className="text-danger">*</span></Label>
              <Input
                name="title"
                type="text"
                placeholder="Enter Email"
                {...formFieldsValidation.title}
                onChange={(event) => handleInput(event, "title")}
                value={formFields.sub_type}
                required
              />
              {errors.title && (
                <span className="mt-1 text-danger">{errors.title.message}</span>
              )}
            </div>
            <div className="w-full ">
              <Label>Sub Title<span className="text-danger">*</span></Label>
              <Input
                name="subTitle"
                type="text"
                placeholder="Enter Sub Title"
                {...formFieldsValidation.subTitle}
                onChange={(event) => handleInput(event, "subTitle")}
                value={formFields.subTitle}
                required
              />
              {errors.subTitle && (
                <span className="mt-1 text-danger">
                  {errors.subTitle.message}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Category Name<span className="text-danger">*</span></Label>
              <Input
                name="category"
                type="text"
                placeholder="Enter Category"
                {...formFieldsValidation.category}
                onChange={(event) => handleInput(event, "category")}
                value={formFields.category}
                required
              />
              {errors.category && (
                <span className="mt-1 text-danger">
                  {errors.category.message}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Cover Image</Label>

              <UploadComponent addFile={setFile}></UploadComponent>
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Blog Data<span className="text-danger">*</span></Label>
              <ReactQuill
                theme="snow"
                modules={modules}
                formats={formats}
                value={formFields.data}
                onChange={(event) => handleInput(event, "data")}
              />
              {errors.data && (
                <span className="mt-1 text-danger">{errors.data.message}</span>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="d-flex customModalFooter">
        <button
          className="btn bg-primary"
          onClick={() => {
            createBlogsData();
          }}
        >
          Create
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateBlogModal;
